var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNarrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30273 3.536C7.63027 3.86353 7.63027 4.39457 7.30273 4.72211L4.86353 7.16131H13.1613C13.6245 7.16131 14 7.53682 14 8.00002C14 8.46323 13.6245 8.83873 13.1613 8.83873H4.86353L7.30273 11.2779C7.63027 11.6055 7.63027 12.1365 7.30273 12.464C6.9752 12.7916 6.44416 12.7916 6.11662 12.464L2.24565 8.59308C1.91812 8.26554 1.91812 7.7345 2.24565 7.40696L6.11662 3.536C6.44416 3.20846 6.9752 3.20846 7.30273 3.536Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNarrowLeft);
export default __webpack_public_path__ + "static/media/arrowNarrowLeft.e2c13d92d570465e3138844dbc93c3ee.svg";
export { ForwardRef as ReactComponent };